<template>

  <div>
    <div class="d-fle justify-content-center align-items-center mb-1">
      <h1>{{ blankData.descricao }}</h1>
      <p><strong>INICIO:</strong> {{ blankData.data_inicio_validade | formatDateBr }} - <strong>TERMINO:</strong>
        {{ blankData.data_termino_validade | formatDateBr }}</p>
    </div>
    <!-- Form add Item tabela preco -->
    <form-add-item-tabela-preco
      :value="formAddItemTabelaPreco"
      :options-items="optionsItemProdutos"
      @updateOptionsItems="updateOptionsItems"
      @saveItem="saveTabelaPrecoItem($event)"
      @cancel="resetFormAddItemTabelaPreco"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refTabelaPrecoItemTable"
        class="position-relative"
        :items="findAllTabelaPreco"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #head(actions)="data">
          <span style="display: flex;justify-content: end">{{ data.label }}</span>
        </template>

        <template #cell(id)="data">
          <b-link
            :to="{ name: 'app-admin-tabela-precos-add-item', params: { id: data.value }}"
            class="font-weight-bold text-nowrap mb-0"
          >
            #{{ data.value }}
          </b-link>
        </template>

        <template #cell(data_inclusao)="data">
          {{ data.value | formatDateTimeBr }}
        </template>
        <template #cell(preco_venda)="data">
          {{ data.value | currency }}
        </template>
        <template #cell(item_nome)="data">
          {{
            data.item.item.item_nome.length > 30 ? data.item.item.item_nome.substring(0, 30) + '...' : data.item.item.item_nome
          }}
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div
            class="row justify-content-end align-content-center"
            style="gap: 5px"
          >
            <feather-icon
                v-if="$can('write', 'Vendedor')"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-tooltip.hover.top="'Editar'"
              style="color: var(--info);"
              size="20"
              class="icon-activity"
              icon="EditIcon"
              @click.stop="editarTabelaPreco(data.item.id)"
            />
            <feather-icon
                v-if="$can('delete', 'Vendedor')"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-tooltip.hover.top="'Deletar'"
              v-b-modal.modal-confirme-delete-grupo
              size="20"
              style="color: var(--danger);"
              icon="TrashIcon"
              class="icon-activity"
              @click.stop="idTabelaPreco = data.item.id"
            />
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
              dataMeta.of
            }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalTabelaPreco"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <ModalConfirm
      id-modal="modal-confirme-delete-grupo"
      title-modal="Excluir Grupo"
      label-btn-ok="Deletar"
      variant-label-btn-ok="danger"
      variant-label-btn-cancel="secondary"
      message="Deseja realmente excluir o grupo?"
      @ok="deleteTabelaPrecoItem"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BPagination, VBModal, BLink, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
  ref, onUnmounted, onMounted,
} from '@vue/composition-api'
import { getUserData } from '@/auth/utils'
import ModalConfirm from '@/components/ModalConfirm.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import {
  formatDateTimeBr, formatDateBr, avatarText, currency,
} from '@/@core/utils/filter'
import router from '@/router'
import FormAddItemTabelaPreco from './FormAddItemTabelaPreco.vue'
import TabelaPrecoStoreModule from '../TabelaPrecoStoreModule'
import UserListAddNew from './AddItemTabelaPrecoListAddNew.vue'
import useTabelaPrecoItemList from './useTabelaPrecoItemList'

export default {
  components: {
    FormAddItemTabelaPreco,
    UserListAddNew,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    ModalConfirm,
    BLink,
    vSelect,
  },
  filters: {
    avatarText,
    formatDateTimeBr,
    currency,
    formatDateBr,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    const toast = useToast()
    const USER_APP_STORE_MODULE_NAME = 'appTabelaPreco'
    const blankData = ref({
      id: null,
      descricao: '',
      data_inicio_validade: null,
      data_termino_validade: null,
    })
    const {
      findAllTabelaPreco,
      tableColumns,
      perPage,
      currentPage,
      totalTabelaPreco,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTabelaPrecoItemTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      idTabelaPrecoFilter,
      dataInicioValidadeFilter,
      dataTerminoValidadeFilter,
    } = useTabelaPrecoItemList()
    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, TabelaPrecoStoreModule)
    const gruposOptions = ref([])
    const optionsItemProdutos = ref([])
    const formAddItemTabelaPreco = ref({
      id: null,
      id_item: null,
      id_tabela_preco: null,
      preco_venda: null,
    })

    const updateFilters = e => {
      store.dispatch('appAdmTabelaPrecoItem/findAll')
    }

    const updateOptionsItems = e => {
      if (typeof e === 'undefined') {
        const userData = getUserData()
        store.dispatch('appAdmProdutos/findAllbyVendedor', {
          perPage: 5,
          sortBy: 'data_inclusao',
          sortDesc: true,
          id_vendedor: userData?.vendedor?.id || null,
        })
          .then(res => {
            optionsItemProdutos.value = res.data.data
          })
        return
      }

      optionsItemProdutos.value = e
    }

    const resetFormAddItemTabelaPreco = e => {
      formAddItemTabelaPreco.value = {
        id: null,
        id_item: null,
        id_tabela_preco: null,
        preco_venda: null,
      }
      updateFilters()
      updateOptionsItems()
      refetchData()
    }

    const saveTabelaPrecoItem = e => {
      formAddItemTabelaPreco.value = e
      if (e.id === null) {
        store.dispatch('appAdmTabelaPrecoItem/create', e)
          .then(res => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Sucesso',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            updateFilters()
            updateOptionsItems()
            refetchData()
            resetFormAddItemTabelaPreco()
          })
          .catch(err => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Não foi possível salvar',
                icon: 'XOctagonIcon',
                variant: 'danger',
                text: err,
              },
            })
            refetchData()
            resetFormAddItemTabelaPreco()
          })
        return
      }

      store.dispatch('appAdmTabelaPrecoItem/update', { formData: e })
        .then(res => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              icon: 'CheckIcon',
              variant: 'success',
              text: res.data.message,
            },
          })
          updateFilters()
          updateOptionsItems()
          refetchData()
          resetFormAddItemTabelaPreco()
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Não foi possível salvar',
              icon: 'XOctagonIcon',
              variant: 'danger',
              text: err,
            },
          })
          refetchData()
          resetFormAddItemTabelaPreco()
        })
    }

    onMounted(() => {
      if (typeof router.currentRoute.params.id === 'undefined') router.push({ name: 'tabela-preco' })
      store.dispatch('appAdmTabelaPreco/findById', { id: router.currentRoute.params.id })
        .then(res => {
          blankData.value = res.data
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Não foi possível carregar',
              icon: 'XOctagonIcon',
              variant: 'danger',
              text: err,
            },
          })
          router.push({ name: 'tabela-preco' })
        })
      idTabelaPrecoFilter.value = router.currentRoute.params.id
      updateOptionsItems()
      store.dispatch('appAdmTabelaPrecoItem/findAll')
    })

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)
    const showAddEditUsuario = e => {
      isAddNewUserSidebarActive.value = e
    }

    const createTabelaPreco = async () => {
      blankData.value = {
        id: null,
        descricao: '',
        data_inicio_validade: null,
        data_termino_validade: null,
      }
      isAddNewUserSidebarActive.value = true
    }

    const editarTabelaPreco = async idTabelaPrecoItem => {
      store.dispatch('appAdmTabelaPrecoItem/findById', { id: idTabelaPrecoItem })
        .then(res => {
          store.dispatch('appAdmProdutos/findAll', {
            q: res.data.item.item_nome,
            sortBy: 'item_nome',
            sortDesc: true,
          })
            .then(response => {
              optionsItemProdutos.value = response.data.items
            })
          formAddItemTabelaPreco.value = {
            id: res.data.id,
            id_item: res.data.item.id,
            id_tabela_preco: res.data.tabela_preco.id,
            preco_venda: res.data.preco_venda,
          }
        })
    }

    const addItemTabelaPreco = async tabelaPrecoId => {
      router.push({ name: 'app-admin-tabela-precos-add-item', params: { id: tabelaPrecoId } })
    }

    const statusOptions = [
      { label: 'Todos', value: '' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    const idTabelaPreco = ref(null)
    const deleteTabelaPrecoItem = async () => {
      await store.dispatch('appAdmTabelaPrecoItem/delete', { id: idTabelaPreco.value })
        .then(resp => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: resp.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          idTabelaPreco.value = null
          refetchData()
        })

      refetchData()
    }
    return {
      idTabelaPrecoFilter,
      idTabelaPreco,
      createTabelaPreco,
      blankData,
      editarTabelaPreco,
      addItemTabelaPreco,
      showAddEditUsuario,
      gruposOptions,
      // Sidebar
      isAddNewUserSidebarActive,
      findAllTabelaPreco,
      tableColumns,
      perPage,
      currentPage,
      totalTabelaPreco,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refTabelaPrecoItemTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      statusOptions,

      // Extra Filters
      roleFilter,
      grupoFilter,
      dataInicioValidadeFilter,
      dataTerminoValidadeFilter,
      updateFilters,
      deleteTabelaPrecoItem,
      optionsItemProdutos,
      updateOptionsItems,
      formAddItemTabelaPreco,
      saveTabelaPrecoItem,
      resetFormAddItemTabelaPreco,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
